import { Projects } from '../project-list';

export const Foodies: Projects = {
  id: 4,
  name: 'Foodies',
  title: 'Foodies: Plan A Food Date with Friends',
  timeLine: 'June 2020 - Present',
  myRole: 'Product Designer',
  team: 'One Product Designer',
  technology: 'Swift and Figma',
  content:
    // '<hr><h2>Introduction</h2><p></p><hr><h2>Process</h2><p></p><hr><h2>Looking Ahead</h2><p></p>',
    'Coming Soon...',
  description: 'Coming Soon...',
  key: 'Foodies',
  date: 'July 2020 - Present',
  imageUrl: 'assets/Images/Foodies.png',
  buttonText: 'Code Coming Soon...',
  buttonUrl: '#',
};
